export const fileSizes = [
  { code: 'xs', size: '200x200' },
  { code: 'sm', size: '480x320' },
  { code: 'md', size: '640x480' },
  { code: 'lg', size: '800x600' },
  { code: 'xl', size: '1024x768' }
]